module.exports = __webpack_public_path__ + "static/media/MurrahLighting.4d56adf8.pdf";